var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateGreyLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 410,
    viewBox: "0 0 445 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.777146 0.62932 0.62932 0.777146 122.573 164.732)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 279.277,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.777146 0.62932 0.62932 0.777146 266.706 149.892)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.777146 0.62932 0.62932 0.777146 77.0095 303.505)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 234.905,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.777146 0.62932 0.62932 0.777146 326.542 -0.428711)",
    fill: "#435E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateGreyLines);
export default __webpack_public_path__ + "static/media/empty-state-grey-lines.612b436c687e468f827b54c8b7dbc4fd.svg";
export { ForwardRef as ReactComponent };